(function () {
  // Runs once per page even though every card includes the tag.
  if (window.__cardVideoInit) return;
  window.__cardVideoInit = true;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var videos = document.querySelectorAll('[data-card-video]');
  if (!videos.length || !('IntersectionObserver' in window)) return;

  // Optional per-video speed, e.g. data-playback-rate="1.25". load() resets the
  // rate, so it is re-applied once metadata is ready and again before play().
  function applyRate(video) {
    var rate = parseFloat(video.getAttribute('data-playback-rate'));
    if (rate > 0) {
      video.defaultPlaybackRate = rate;
      video.playbackRate = rate;
    }
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var video = entry.target;
      if (entry.isIntersecting) {
        if (video.preload === 'none') {
          video.preload = 'auto';
          video.load();
        }
        applyRate(video);
        var attempt = video.play();
        if (attempt && attempt.then) {
          attempt.then(function () {
            applyRate(video);
            video.classList.add('is-playing');
          }).catch(function () {
            // Autoplay refused (data saver / low power mode). Poster image stays.
          });
        }
      } else {
        video.pause();
        video.classList.remove('is-playing');
      }
    });
  }, { rootMargin: '100px 0px', threshold: 0.4 });

  videos.forEach(function (video) {
    video.addEventListener('loadedmetadata', function () { applyRate(video); });
    observer.observe(video);
  });
})();
